module.exports = __webpack_public_path__ + "img/logo_Belfius_Insurance.8efb2fb9.png";